import React, { useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { AuthContext } from 'features/auth/context/Auth';
import Loader from 'features/Loader/Loader';
import WorkoutList from './workoutList';
import './workout.scss';
import { getWorkouts } from '../ducks/workoutActions';

const Workout = props => {
  const { currentUser } = useContext(AuthContext) || {};

  //component did mount
  useEffect(() => {
    props.getWorkouts(currentUser.uid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let { workouts, loading } = props;

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="workout main-wrapper">
      <div className="container">
        <div className="page-title">
          <h4>Workouts</h4>
          <div className="title-action">
            <Link to="/workouts/new" className="btn btn-primary">
              Create Workout
            </Link>
          </div>
        </div>
        <WorkoutList workouts={workouts} />
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    workouts: state.workoutReducer.workouts,
    loading: state.workoutReducer.loading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getWorkouts: trainerId => dispatch(getWorkouts(trainerId))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Workout);
